import { ulid } from "ulid";
import axios from "axios";
export default {
  methods: {
    async ocrScanInvoice(file) {
      const form = new FormData();
      form.append("file", file);
      form.append("ulid", ulid());

      return axios.post("/api/v2/ocr_scan_batches", form, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    }
  }
};
